import React from 'react';
import cn from 'classnames';

import CN from './FlareStar.module.scss';

const FlareStar = ({ variant, animation, top, left, right, bottom, size }) => (
  <div
    data-bem="FlareStar"
    style={{
      top: `${top}px`,
      left: `${left}px`,
      right: `${right}px`,
      bottom: `${bottom}px`,
      backgroundSize: `${size}px`,
    }}
    className={cn({
      [CN.component]: true,
      [CN[`${variant}Variant`]]: variant,
      [CN[`${animation}Animation`]]: animation,
    })}
  />
);

export default FlareStar;
